import React, { useContext } from 'react';
import {
  Dropdown,
  DropdownContent,
  DropdownToggle,
} from '@prisjakt/ui/dropdown';
import { Direction } from '@prisjakt/ui';
import { AppState } from 'src/reducers';
import { AppContext } from '@prisjakt/ui-app-context';
import { useSelector } from 'react-redux';
import { translateSort } from './utils';
import { defaultProductState } from 'src/areas/product/reducer';
import SortIcon from 'mdi-react/SortDescendingIcon';
import { ButtonIcon, ButtonType } from '@prisjakt/ui/button/variants';
import { SortOptions } from './sort-options';
import * as S from './styles';

export const OfferlistSorting = () => {
  const { t } = useContext(AppContext);
  const currentSort =
    useSelector((state: AppState) => getSortState(state)) ||
    defaultProductState.sorting;

  return (
    <S.SortingOptions>
      <Dropdown closeOnItemClick>
        <DropdownToggle showActiveIcon type={ButtonType.TEXT}>
          <ButtonIcon>
            <SortIcon />
          </ButtonIcon>
          <S.ButtonText>{translateSort(t, currentSort)}</S.ButtonText>
        </DropdownToggle>
        <DropdownContent alignment={Direction.Right}>
          <SortOptions renderAllOptions={false} />
        </DropdownContent>
      </Dropdown>
    </S.SortingOptions>
  );
};

const getSortState = (state: AppState) => state.areas.product.sorting;
